import { render, staticRenderFns } from "./QuestionsList.vue?vue&type=template&id=7bc4c290&"
import script from "./QuestionsList.js?vue&type=script&lang=js&"
export * from "./QuestionsList.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports